import isPropValid from '@emotion/is-prop-valid';
import rtlPlugin from 'stylis-plugin-rtl';
import { StyleSheetManager } from 'styled-components';
import useIsRtl from '@app/hooks/useIsRtl';

interface Props {
  children: React.ReactNode;
}

// This implements the default behavior from styled-components v5
const shouldForwardProp = (propName: string, target: any) => {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
};

const RtlStyles = ({ children }: Props) => {
  const isRtl = useIsRtl();

  if (!isRtl) {
    return children;
  }

  // @ts-ignore
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp} stylisPlugins={[rtlPlugin]}>
      {children}
    </StyleSheetManager>
  );
};

export default RtlStyles;
